<template>
    <provider-listing :query="{npi, tier, specialty, category, subcategory, location}" class="white-cards" />
</template>

<script>
import ProviderListing from './ProviderListing.vue';

export default {
    components: {ProviderListing},

    props: {
        npi: {type: Array, default: null},
        tier: {type: Array, default: null},
        category: {type: Array, default: null},
        subcategory: {type: Array, default: null},
        specialty: {type: Array, default: null},
        location: {type: Array, default: null},
    },

    created() {
        this.$store.dispatch('getProviders', {all: true, npi: this.npi, tier: this.tier, category: this.category, subcategory: this.subcategory, specialty: this.specialty, location: this.location});
    },
};
</script>
